export const GRID_COLOR = "var(--divider-color)";
export const LINE_COLOR = "var(--brand-color)";
export const BAR_COLOR = "var(--brand-color)";

export const BAR_WIDTH = 8;
